<template lang="pug" src="./orders-layout.pug"></template>
<style lang="scss" src="./orders-layout.scss" scoped></style>

<script>
import {mapGetters, mapState} from 'vuex';
import axios from 'axios';
import request from '@/utils/request';
import config from '../../../../../config.json';
import createOrder from '@/views/pages/ReceiveOrders/active-order';
import createDeliveryOrder from '@/views/pages/ReceiveOrders/active-delivery-order';
import order from '@/views/pages/ReceiveOrders/order';
import helpers from '@/utils/helpers';
import notify from '@/plugins/notify';
import Vue from 'vue';
import {cnb} from "cnbuilder";
import {VAutocomplete} from "vuetify/lib/components";

export default {
  components: {
    'v-create-order': createOrder,
    'v-order': order,
    'v-autocomplete': VAutocomplete
  },
  filters: {
    operator(dto) {
      return cnb(dto.firstName, dto.middleName, dto.lastName, dto.phone ? `(${dto.phone})` : '');
    }
  },
  data: () => ({
    orders: [],
    sendOrderRequest: true,
    delegateModal: false,
    updatedAfter: null,
    updateOrdersTimer: null,
    hoverOrderIndex: null,
    orderReceiver: null,
    showHistory: true,
    loading: false,
    optionLevelModal: false,
    currentLevel: null,
    requestProcessing: false,
    newLevel: 0
  }),
  computed: {
    ...mapGetters(['user', 'operator', 'roleName']),
    ...mapState({
      drawer: (state) => state.data.drawer,
      operators: s => s.data.operators
    }),
    activeOrderComponent() {
      if (!this.activeOrder) {
        return null;
      }

      if (this.activeOrder.isDelivery) {
        return createDeliveryOrder;
      }

      return createOrder;
    },
    isShowHistory: {
      get() {
        return this.$store.state.orders.isShowHistory;
      },
      set(value) {
        this.$store.commit('orders/SET_IS_SHOW_HISTORY', value);
      }
    },
    activeOrder() {
      return this.orders.find(order => order[this.activityKey] === true);
    },
    canCreateOrders() {
      if (!this.user) {
        return false;
      }

      return !['admin-delivery', 'manager-establishment', 'manager-establishment-ext', 'admin-establishment'].includes(this.user.roleName);
    },
    canDelegateOrders() {
      return ['operator'].includes(this.roleName);
    },
    activityKey() {
      return ['manager-establishment', 'manager-establishment-ext', 'admin-establishment'].includes(this.user.roleName) ? 'isActiveInEstablishment' : 'isActive';
    },
    hasActiveOrder: function () {
      return this.orders && this.orders.some((order) => {
        return order[this.activityKey];
      });
    },
    showHistoryIcon() {
      return this.showHistory ? 'dynamic_feed' : 'open_in_new';
    },
    validNewLevel() {
      return this.newLevel >= 0 && this.newLevel < 6 && this.newLevel != this.currentLevel;
    }
  },
  created: async function () {
    this.updateOrdersTimer = setInterval(() => {
      if (this.sendOrderRequest) {
        this.updateOrders();
      }
    }, config.ordersPollingInterval);

    if (this.sendOrderRequest) {
      this.updateOrders();
    }

    this.$store.dispatch('orders/getBrandDetails');
    this.$store.dispatch('data/getBrands');
    this.$store.dispatch('data/getOperators');
  },
  mounted: function () {
    window.addEventListener('keyup', this.keydownHandler);
  },
  beforeDestroy: function () {
    window.removeEventListener('keyup', this.keydownHandler);
    clearInterval(this.updateOrdersTimer);
    this.updateOrdersTimer = null;
  },
  methods: {
    openDelegateModal() {
      this.delegateModal = true;
    },
    closeDelegateModal() {
      this.delegateModal = false;
      this.orderReceiver = null;
    },
    delegateOrders() {
      this.$store.dispatch('orders/delegateAllToOperator', this.orderReceiver);

      this.closeDelegateModal();
    },
    onDisactiveOrder(orderId) {
      this.setActiveById(orderId, false);
    },

    onActiveOrder(orderId) {
      this.setActiveById(orderId, true);
    },

    setActiveById(orderId, value) {
      const orderIndex = this.orders.findIndex(it => it.id == orderId);

      this.$set(this.orders, orderIndex, Object.assign({}, this.orders[orderIndex], {
        [this.activityKey]: value
      }));
    },

    updateOrders: async function () {
      const params = {
        userId: this.user.id
      };

      if (this.updatedAfter) {
        params.updatedAfter = this.updatedAfter;
      }

      if (this.orders.length > 0) {
        params.orderIds = this.orders.map('id').join(',');

        if (!this.hasActiveOrder) {
          this.orders.sort(function (a, b) {
            if (b.isSos !== a.isSos) {
              return b.isSos - a.isSos;
            } else if (b.needsOperatorAttention !== a.needsOperatorAttention) {
              return b.needsOperatorAttention - a.needsOperatorAttention;
            }

            return Date.parse(a.createdAt) - Date.parse(b.createdAt);
          });
        }
      }

      if (this.hasActiveOrder) {
        return;
      }

      await axios({
        method: 'get',
        url: process.env.VUE_APP_SERVER + '/orders',
        params,
        timeout: 5000
      }).then((res) => {
        res.data.forEach((order) => {
          if (order.delegatedOperatorId) {
            order.operatorId = order.delegatedOperatorId;
            order.operator = order.delegatedOperator;

            delete order.delegatedOperatorId;
            delete order.delegatedOperator;
          }

          // remove orders with status cancelled
          const removeCancelledDriver = order.status === 'cancelled' && order.cancelledBy === 'driver' && order.operatorId == null && !order.fromInternet;
          const removeCancelledClient = order.status === 'cancelled' && order.cancelledBy === 'client' && order.fromInternet;
          const removeCancelledOther = order.status === 'cancelled' && ['operator', 'system'].includes(order.cancelledBy);

          //remove taxi orders with status 'landed', 'completed'
          const orderStatusesForRemoveTaxi = ['landed', 'completed'];

          if ((orderStatusesForRemoveTaxi.includes(order.status) && !order.isDelivery) || order.hidden || ((removeCancelledClient || removeCancelledDriver || removeCancelledOther) && !order.isDelivery) || (['manager-establishment', 'manager-establishment-ext', 'admin-establishment'].includes(this.user.roleName) && order.status === 'landed') ||
              (order.operator && order.operator.user.id !== this.user.id && !['manager-establishment', 'manager-establishment-ext', 'admin-establishment'].includes(this.user.roleName) && order.operator.operatorStatus === 'online') ||
              (['admin-establishment', 'manager-establishment', 'manager-establishment-ext'].includes(this.user.roleName) && order.establishmentManager && order.establishmentManager.user.id !== this.user.id && order.establishmentManager && order.operator.establishmentManager.operatorStatus === 'online') ||
              (this.user && this.user.brandId && this.user.brandId !== order.brandId)
          ) {
            return this.orders.remove({id: order.id});
          }
          if (!document.hasFocus() &&
              ['operator', 'admin', 'intern'].includes(this.user.roleName) &&
              (!this.user.brandId || this.user.brandId == order.brandId) &&
              (order.isSos || ['new', 'cancelled'].includes(order.status))
          ) {
            notify.makeNotify(order, this.$vuetify.lang.current).show();
          }

          order.addresses = order.unorderedAddresses
              .sortBy('sortOrder')
              .map('place')
              .map(it => Vue.filter('extendAddress')(it));

          let existingOrder = this.orders.find({id: order.id});
          const orderIndex = this.orders.findIndex(it => it.id == order.id);

          if (existingOrder) {
            this.$set(this.orders, orderIndex, Object.assign({}, existingOrder, order));
          } else {
            this.orders.push(order);
          }
        });

        if (res.data.length > 0) {
          this.updatedAfter = res.data.max('updatedAt').updatedAt;
        }
      });
    },

    addOrder: async function () {
      if (this.loading) return;

      this.loading = true;

      let phoneNumber = helpers.isCorporate(this.user) ? this.user.phoneNumber : config.defaultTaxiNumber;
      let pexten = config.defaultTaxiNumber;

      if (this.user.brand) {
        phoneNumber = pexten = this.user.brand.phoneNumber;
      }

      await this.$store.dispatch('orders/createOrder', {
        phoneNumber: phoneNumber && phoneNumber.toString(),
        pexten
      }).then(() => {
        this.updateOrders();
      }).finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 300);
      });
    },

    keydownHandler: function (e) {
      this.hoverOrderIndex = this.orders.findIndex(it => it.isHover);

      if (e.keyCode == 40) {
        if (this.hoverOrderIndex != -1) {
          Vue.set(this.orders[this.hoverOrderIndex], 'isHover', false);

          if (this.hoverOrderIndex != this.orders.length - 1) {
            Vue.set(this.orders[this.hoverOrderIndex + 1], 'isHover', true);
          } else {
            Vue.set(this.orders[0], 'isHover', true);
          }

        } else if (this.orders.length) {
          Vue.set(this.orders[0], 'isHover', true);
        }
      }

      if (e.keyCode == 38) {
        if (this.hoverOrderIndex != -1) {
          Vue.set(this.orders[this.hoverOrderIndex], 'isHover', false);

          if (this.hoverOrderIndex != 0) {
            Vue.set(this.orders[this.hoverOrderIndex - 1], 'isHover', true);
          } else {
            Vue.set(this.orders[this.orders.length - 1], 'isHover', true);
          }
        } else if (this.orders.length) {
          Vue.set(this.orders[this.orders.length - 1], 'isHover', true);
        }
      }

      if (e.keyCode == 13) {
        if (this.hoverOrderIndex != -1 && !this.orders.filter(it => it[this.activityKey]).length) {
          this.$store.dispatch('orders/makeActiveOrder', this.orders[this.hoverOrderIndex].id)
              .then(res => {
                if (res) {
                  this.onActiveOrder(this.orders[this.hoverOrderIndex].id);
                }
              });
        }
      }
    },

    disableActiveHover: function () {
      this.orders.forEach(it => {
        if (it) {
          it.isHover = false;
        }
      });
    },

    openChangeOptionModal() {
      this.optionLevelModal = true;
      this.getCurrentOptionLevel();
    },

    async getCurrentOptionLevel() {
      if (this.requestProcessing) return;

      this.requestProcessing = true;

      await request({
        method: 'get',
        url: `/admin/option-level/current`
      }).then(res => {
        this.currentLevel = res.data.level;
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.error) {
          this.$store.dispatch('alert/addMessage', {
            message: error.response.data.error
          });
        }
      }).finally(() => {
        this.$nextTick(() => {
          this.requestProcessing = false;
        });
      });
    },

    async changeCurrentOptionLevel() {
      if (this.requestProcessing) return;

      this.requestProcessing = true;

      await request({
        method: 'post',
        url: `/admin/option-level/current`,
        data: {
          level: this.newLevel
        }
      }).then(res => {
        if (res.status == 204) {
          this.currentLevel = this.newLevel;
          this.optionLevelModal = false;
        }
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.error) {
          this.$store.dispatch('alert/addMessage', {
            message: error.response.data.error
          });
        }
      }).finally(() => {
        this.$nextTick(() => {
          this.requestProcessing = false;
        });
      });
    }
  }
};
</script>
